// CUSTOM ASSET — added for color combined-listings.
// See /CHANGELOG.md for the full list of custom changes in this theme.
//
// On collection pages, hovering a swatch previews that color's
// product image on the card — no page reload. Clicking still
// navigates to that color's product page (each color is a
// separate product/URL, so this is not an in-place variant swap).

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.card-wrapper').forEach(function (card) {
    var img = card.querySelector('.card__media img, .media img');
    if (!img) return;

    var originalSrc = img.getAttribute('src');

    card.querySelectorAll('.color-swatch').forEach(function (swatch) {
      var previewUrl = swatch.getAttribute('data-swatch-preview');
      if (!previewUrl) return;

      swatch.addEventListener('mouseenter', function () {
        img.setAttribute('src', previewUrl);
      });

      swatch.addEventListener('mouseleave', function () {
        img.setAttribute('src', originalSrc);
      });
    });
  });
});
